import { AxiosHeaders } from 'axios';

export function applyPermissionContextHeaders(headers: AxiosHeaders, companyId: number | null, siteId: number | null): void {
  // A visit may explicitly name a site outside the selected company. Its own scope takes priority.
  if (headers.has('X-Site-Id') || headers.has('X-Company-Id')) return;
  if (companyId != null) headers.set('X-Company-Id', String(companyId));
  if (siteId != null) headers.set('X-Site-Id', String(siteId));
}

export function permissionContextKey(tenantId: number | null, companyId: number | null, siteId: number | null): string | null {
  return tenantId == null ? null : `api/users/me/permissions::tenant:${tenantId}::company:${companyId ?? '_'}::site:${siteId ?? '_'}`;
}
